// @flow

import {Environment} from 'relay-runtime'
import {commitMutation, graphql, } from 'react-relay'

const addMutation = graphql`
    mutation CategoryAddMutation(
        $input: CategoryAddInput!
    ) {
        CategoryAdd(input: $input) {
            CategoryEdge {
                node {
                    id
                }
            },
            error
        }
    }
`

export function commit(environment: Environment, params: any, callback: (error: ?Error, id: ?string) => void) {
    console.table('params');
    console.table(params);
    console.table('callback');
    console.table(callback);
    commitMutation(
        environment,
        {
            mutation: addMutation,
            variables: {
                input: params
            },
            onCompleted: (response) =>{
                if (response.error !== null && response.error !== undefined) {
                    callback(response.error, null);
                    return
                }
                callback(null, response.CategoryAdd.CategoryEdge.node.id)
            },
            onError: (error) => {
                callback(error, null)
            },
        })
}



// WEBPACK FOOTER //
// src/mutations/CategoryAddMutation.js